var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"mi",style:(_vm.style)},[_c('use',{attrs:{"xlink:href":("#" + _vm.id)}})])}
var staticRenderFns = []

export { render, staticRenderFns }